import {Age} from "./age";
import {Gender} from "../../enums/gender";
import {ResultType} from "../../enums/result-type";

export class NumericClinicalRange {
  maxAge: Age;
  minAge: Age;
  normalFrom: number;
  normalTo: number;
  criticalFrom: number;
  criticalTo: number;
  unitOfMeasure: string;
  reportComment: string;
  effectiveDate: Date;
  gender: Gender;
  resultType: ResultType;

  constructor({
                maxAge,
                minAge,
                normalFrom,
                normalTo,
                criticalFrom,
                criticalTo,
                unitOfMeasure,
                reportComment,
                effectiveDate,
                gender,
                resultType
              }: NumericClinicalRange) {
    this.maxAge = maxAge;
    this.minAge = minAge;
    this.normalFrom = normalFrom;
    this.normalTo = normalTo;
    this.criticalFrom = criticalFrom;
    this.criticalTo = criticalTo;
    this.unitOfMeasure = unitOfMeasure;
    this.reportComment = reportComment;
    this.effectiveDate = effectiveDate;
    this.gender = gender;
    this.resultType = resultType;
  }

}
